module.exports = __webpack_public_path__ + "img/negative-div.67d396bf.svg";